export const CapitalizeFirstLetter = (string: string): string => {
  if (string.length === 0) return string;

  if (string.length === 1) return string.toUpperCase();

  return string.charAt(0).toUpperCase() + string.slice(1);
};

export const ToCurrency = (number?: number): string | undefined => {
  return number?.toLocaleString('en-US', {
    style: 'currency',
    currency: 'USD',
  });
};

export const ToDate = (date?: Date | string): string | undefined => {
  if (!date) {
    return '';
  }
  if (!(date instanceof Date)) {
    const isoWithoutTz = /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}(\.\d+)?$/;
    date = new Date(isoWithoutTz.test(date) ? date + 'Z' : date);
  }
  return date?.toLocaleDateString('en-US', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
  });
};

export const ToPercent = (number?: number, digitsConfig?: DigitsConfig): string | undefined => {
  const formatter = new Intl.NumberFormat('en-US', {
    style: 'percent',
    minimumFractionDigits: digitsConfig?.minimumFractionDigits || 2,
    maximumFractionDigits: digitsConfig?.maximumFractionDigits || 2,
  });
  const formattedPercentage = number !== undefined ? formatter.format(number) : '';
  return formattedPercentage;
};

export const ToBooleanYesNo = (value?: boolean) => {
  return value ? 'Yes' : 'No';
};

export class DigitsConfig {
  minimumFractionDigits: number = 2;
  maximumFractionDigits: number = 2;
}
